import moment from 'moment';

type EventDatesResult = {
  closestEvent: string;
  nextEvents: string[];
};

/**
 * Etkinlik tarihlerini işler ve en yakın etkinliği ile sonraki etkinlikleri döner.
 * @param dates ISO string array
 */
export const getEventDatesInfo = (dates: string[]): EventDatesResult => {
  if (!dates || dates.length === 0) return { closestEvent: '', nextEvents: [] };

  // Şu anki günün 00:00'ı
  const now = moment().startOf('day');

  // Geçmişteki tarihleri çıkar, sıralı hale getir
  const futureDates = dates
    .map((d) => moment.utc(d))
    .filter((d) => d.isSameOrAfter(now, 'day'))
    .sort((a, b) => a.valueOf() - b.valueOf());

  if (futureDates.length === 0) return { closestEvent: '', nextEvents: [] };

  // Tek bir tarih varsa
  if (futureDates.length === 1) {
    return {
      closestEvent: futureDates[0].locale('tr').format('D MMMM'),
      nextEvents: [],
    };
  }

  // İlk iki tarih ardışık mı?
  const first = futureDates[0];
  const second = futureDates[1];
  const diff = second.diff(first, 'days');

  if (diff === 1) {
    // Aynı ay mı?
    if (first.month() === second.month()) {
      // 30-31 Aralık gibi
      return {
        closestEvent: `${first.date()}-${second.date()} ${first
          .locale('tr')
          .format('MMMM')}`,
        nextEvents: [],
      };
    } else {
      // 30 Haziran - 1 Temmuz gibi
      return {
        closestEvent: `${first.date()} ${first
          .locale('tr')
          .format('MMMM')} - ${second.date()} ${second
          .locale('tr')
          .format('MMMM')}`,
        nextEvents: [],
      };
    }
  }

  // 1 günden fazla fark varsa
  return {
    closestEvent: first.locale('tr').format('D MMMM'),
    nextEvents: futureDates
      .slice(1)
      .map((d) => d.locale('tr').format('D MMMM')),
  };
};
